import { useState, useMemo, useEffect } from "react";
import { SnowPlowAnalyticsContext } from "../snow-plow-analytics-context";
import {
  initCMODigitalPersonalizationScript,
  initRpTrackerScript,
  initSnowPlowScript,
} from "../utils";
import { SnowPlowAnalyticsProviderProps } from "./types";
import { runSnowPlow } from "./run-snow-plow";
import { runCMODigitalPersonalization } from "./run-cmo-digital-personalization";

export const SnowPlowAnalyticsProvider = ({
  children,
}: SnowPlowAnalyticsProviderProps) => {
  const [isSnowPlowReady, setIsSnowPlowReady] = useState(false);
  const [isRpTrackerReady, setIsRpTrackerReady] = useState(false);
  const [
    isCMODigitalPersonalizationReady,
    setIsCMODigitalPersonalizationReady,
  ] = useState(false);

  useEffect(() => {
    initSnowPlowScript(() => {
      setIsSnowPlowReady(true);
    });
    initCMODigitalPersonalizationScript().then(() => {
      setIsCMODigitalPersonalizationReady(true);
    });
  }, []);

  useEffect(() => {
    if (isSnowPlowReady) {
      try {
        runSnowPlow();
        runCMODigitalPersonalization();

        initRpTrackerScript().then(() => {
          setIsRpTrackerReady(true);
        });
      } catch (e) {
        console.error("SP error:", e);
      }
    }
  }, [isSnowPlowReady]);

  const contextValue = useMemo(
    () => ({
      isRpTrackerReady,
      isCMODigitalPersonalizationReady,
    }),
    [isCMODigitalPersonalizationReady, isRpTrackerReady]
  );

  return (
    <SnowPlowAnalyticsContext.Provider value={contextValue}>
      {children}
    </SnowPlowAnalyticsContext.Provider>
  );
};
